import { FileDoneOutlined } from "@ant-design/icons";
import { Button, Col, notification } from "antd";
import fileDownload from "js-file-download";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { coreApi } from "../../api/calls";

const InvoiceExportButton = ({
  exportAll,
  invoiceTypeTranslationKey,
  invoiceExportTypeAPIEndpoint,
  idCityBranch,
  cityName = "",
  primary = false,
  dateFrom,
  dateTo,
}) => {
  const { t } = useTranslation();

  const [isLoading, setLoading] = useState(false);

  return (
    <Col span={24}>
      <Button
        type={primary ? "primary" : "none"}
        loading={isLoading}
        icon={<FileDoneOutlined />}
        style={{ width: "100%" }}
        onClick={() => {
          setLoading(true);
          coreApi
            .get("/invoices/export" + invoiceExportTypeAPIEndpoint + "/" + idCityBranch, {
              headers: {
                "Content-Encoding": "UTF-8",
                "Content-type": "text/csv",
              },
              responseType: "blob",
              params: {
                exportAll: exportAll,
                dateFrom,
                dateTo,
              },
            })
            .then((response) => {
              fileDownload(response.data, cityName !== "" ? cityName + "-invoice-export.csv" : "invoice-export.csv");
            })
            .catch((err) => {
              notification.error({ message: t("exports.exportError") });
            })
            .finally(() => setLoading(false));
        }}
      >
        {t("exports.invoiceExport")}
      </Button>
    </Col>
  );
};

export default InvoiceExportButton;
